module.exports = __webpack_public_path__ + "img/status-bar-asking.2cf3c7a4.svg";